import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const commonMessages = defineMessages({
  catchphrase: {
    id: 'app.auth.common.catchphrase',
    defaultMessage: 'Environmental impact {br} through energetic data',
  },
  emailRequired: {
    id: 'app.auth.common.emailRequired',
  },
  emailNotValid: {
    id: 'app.auth.common.emailNotValid',
  },
});

export const AuthLayout = defineMessages({
  title: {
    id: 'app.auth.login.Page.title',
  },
  subTitle: {
    id: 'app.auth.login.Page.subTitle',
  },
  loginError: {
    id: 'app.auth.login.Page.loginError',
  },
  identifyError: {
    id: 'app.auth.identify.Page.identifyError',
  },
  userNotFound: {
    id: 'app.auth.identify.Page.userNotFound',
  },
});
